import { useMemo } from 'react'
import { Line } from 'recharts'
import { ChartContainer } from '../../../../common/chart/chartContainer'
import { getYAxisProps } from '../../../../common/chart/chartContainer/helper'
import { responsive } from '../../../../utils/layout'

const CHANGE_FORMAT_SCREEN = 1600

export const ChartComponent = ({ data, width, height, xAxisKey, yAxisKey }) => {
  // Get data
  const yAxisProps = getYAxisProps({
    data,
    yAxis: [
      {
        yAxisId: 'left',
        dataKeys: [yAxisKey],
        isLineChart: true,
        hide: true,
      },
    ],
  })

  const maxYAxisTick = useMemo(() => {
    const ticks = yAxisProps[0]?.ticks
    return ticks ? ticks[ticks.length - 1] : 0
  }, [yAxisProps.length])

  const getXAxisFormat = (val) => {
    if (
      document.body.offsetWidth < CHANGE_FORMAT_SCREEN &&
      document.body.offsetWidth >= responsive.PIVOT_WIDTH
    ) {
      return String(val).substring(2, 4)
    }

    return val
  }

  return (
    <ChartContainer
      data={data}
      width={width}
      height={height}
      cartesianGrid={{ horizontal: true, vertical: true }}
      xAxis={[
        {
          dataKey: xAxisKey,
          tickFormatter: getXAxisFormat,
        },
      ]}
      yAxis={[
        {
          yAxisId: 'left',
          dataKeys: [yAxisKey],
          isLineChart: true,
          hide: true,
          ticks: [0, maxYAxisTick],
        },
        {
          yAxisId: 'right',
          dataKeys: [],
          isLineChart: true,
          hide: true,
        },
      ]}
    >
      <Line
        yAxisId={'left'}
        dataKey={yAxisKey}
        stroke="#F49966"
        strokeWidth={2}
        dot={{ fill: '#F49966', r: 2 }}
      />
    </ChartContainer>
  )
}
